import { useState } from 'react';

export function useDrawer() {
  const [showDrawer, setShowDrawer] = useState(false);

  const openDrawer = () => {
    setShowDrawer(true);
  };

  const closeDrawer = () => {
    setShowDrawer(false);
  };

  return {
    openDrawer,
    closeDrawer,
    showDrawer,
  };
}
